import React from 'react'
import styled from 'styled-components'
import StatisticsTableRow from './StatisticsTableRow'
import LoadingBar from './LoadingBar'

const StatisticsTable: React.FC<{
    isLoading: boolean
    rows: StatisticsTableRow[]
    backgroundColorType?: 'card' | 'card-card'
}> = ({ isLoading, rows, backgroundColorType }) => {
	const isNested = backgroundColorType === 'card-card'

	return (
		<Table $nested={isNested}>
			<tbody>
				{rows.map(row => (
					<tr key={row.id}>
						<Th $nested={isNested}>
							<Image src={row.icon} alt={''} />
							{row.name}
						</Th>

						<Td $nested={isNested}>
							<h5 className={'d-flex flex-row justify-content-end'} style={{margin: 0, height: '32px', alignItems: 'center'}}>
								{isLoading ? (
									<div style={{width: '100%'}}>
										<LoadingBar size={3} />
									</div>
								) : (
									<>
										<CountValue>{row.value}</CountValue>
										{row.extraValue && (
											<ExtraValue>{row.extraValue}</ExtraValue>
										)}
									</>
								)}
							</h5>
						</Td>
					</tr>
				))}
			</tbody>
		</Table>
	)
}

const Table = styled.table<{$nested: boolean}>`
	margin: 0;
	width: 100%;

	tbody {
		background-color: transparent !important;
	}

	tr {
		&:hover {
			background-color: ${({$nested}) => $nested ? 'var(--card-bg-color)' : 'var(--hover-bg-color)'};
		}
	}
`

const Th = styled.th<{$nested: boolean}>`
	padding: 10px 8px;
	color: var(--text-color);
	font-size: 1.1rem;
	font-weight: normal;
	border-bottom: 1px solid ${({$nested}) => $nested ? 'var(--card-bg-color)' : 'var(--hover-bg-color)'};
`

const Td = styled.td<{$nested: boolean}>`
	padding: 10px 8px;
	color: var(--text-color);
	border-bottom: 1px solid ${({$nested}) => $nested ? 'var(--card-bg-color)' : 'var(--hover-bg-color)'};
	text-align: right;
`

const Image = styled.img.attrs({
	className: 'img-fluid me-3 force-1-line',
})`
	width: 30px;
	height: 30px;
`

const CountValue = styled.span`
	min-width: 40px;
	text-align: right;
	margin-right: 5px;
`

const ExtraValue = styled.div`
	padding-top: 7px;
	margin: 0;
	font-size: 14px;
	color: var(--sub-text-color);
	min-width: 45px;
	text-align: right;
`

export default StatisticsTable
